<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
  >
    <template slot="select">
      <FormItem>
        <Select
          v-model="searchFrom.warehouseId"
          filterable
          clearable
          placeholder="Please Select Warehouse"
        >
          <Option
            v-for="item in objWarehouse"
            :value="item.id"
            :key="item.id"
            >{{ item.warehouse_name }}</Option
          >
        </Select>
      </FormItem>
    </template>
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick(0, 'add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>

    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="140"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <template v-if="crudText != 'update'">
            <FormItem :label="$t('warehouseName')" prop="warehouse_id">
              <Select
                v-model="dataDetails.warehouse_id"
                filterable
                placeholder="Please Select Warehouse"
                :disabled="disabled"
              >
                <Option
                  v-for="item in objWarehouse"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.warehouse_name }}</Option
                >
              </Select>
            </FormItem>
            <Divider />
          </template>
          <Tooltip
            :key="tag.tracker_code"
            v-for="tag in tableData"
            effect="dark"
            :content="tag.tracker_description"
            placement="top-start"
          >
            <template v-if="crudText != 'show'">
              <Tag
                type="dot"
                closable
                color="primary"
                @on-close="handleClose(tag)"
                >{{ tag.tracker_code }}</Tag
              >
            </template>
            <template v-else>
              <Tag type="dot" closable color="primary">{{
                tag.tracker_code
              }}</Tag>
            </template>
          </Tooltip>
          <template v-if="crudText != 'show'">
            <template v-if="inputVisible"
              ><Select
                v-model="code"
                placeholder="Please Select Status"
                filterable
                @on-change="checkCode"
                style="width: 150px"
              >
                <Option
                  v-for="item in statusList"
                  :key="item.tracker_code"
                  :value="item.tracker_code"
                  >{{ item.tracker_code }}</Option
                >
              </Select>
            </template>
            <Button v-else @click="addClick">+ Add</Button>
          </template>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import {
  add,
  getDriverStatus,
  getDetails,
  update,
  del,
} from "@/api/system/driver_status";
import { getStatus } from "@/api/tracker/status";
import common from "_c/common-body";
import basic from "@/utils/basic";
import nodata from "@/utils/nodata";
import boxMes from "@/utils/message";

export default {
  name: "driver_status",
  components: {
    common,
  },
  data() {
    return {
      current: 1,
      objWarehouse: {},
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
        warehouseId: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        warehouse_id: [
          {
            required: true,
            type: "number",
            message: "warehouse cannot be empty",
            trigger: "change",
          },
        ],
        allow_status: [
          {
            required: true,
            type: "string",
            message: "status cannot be empty",
            trigger: "blur",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      inputVisible: false,
      code: "",
      tableData: [],
      oldList: [],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("warehouseName"),
        key: "warehouse_name",
        align: "center",
        minWidth: 150,
      });
      columns.push({
        title: this.$t("allow_status"),
        key: "allow_status",
        align: "center",
        minWidth: 500,
        tooltip: true,
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        minWidth: 250,
      });
      return columns;
    },
  },
  watch: {
    dataDetails: {
      handler: function (nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.objWarehouse = basic.objWarehouse();
    this.getList(this.searchFrom);
    this.getOtherList();
  },
  methods: {
    addClick() {
      this.inputVisible = true;
    },
    handleClose(tag) {
      this.unChange = false;
      this.tableData = this.tableData.filter(
        (item) => item.tracker_code !== tag.tracker_code
      );
    },
    checkCode() {
      let _this = this;
      _this.$nextTick(() => {
        _this.inputVisible = false;
        let isEqual = false;
        let desc = _this.statusList.filter(
          (item) => item.tracker_code === _this.code
        )[0].tracker_description;
        _this.tableData.some((item) => {
          if (item.tracker_code == _this.code) {
            isEqual = true;
          }
        });
        if (isEqual) {
          _this.inputVisible = false;
          this.$Message["error"]({
            background: true,
            content: "Please do not repeat selection",
          });
        } else {
          _this.tableData.push({
            tracker_code: this.code,
            tracker_description: desc,
          });
          this.unChange = false;
        }
        _this.code = "";
      });
    },
    getOtherList() {
      getStatus()
        .then((res) => {
          this.statusList = res.data.payload.rows;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeBindModal(val) {
      if (!val) {
        this.isshowModal = false;
        this.tableData = [];
        this.inputVisible = false;
      } else {
        if (this.crudText === "delete") {
          this.deleteList(this.delId);
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.tableData = [];
        this.isshowModal = false;
        this.inputVisible = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.crudText === "add") {
            this.addList();
          } else {
            this.updateList();
          }
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    crudClick(item, text) {
      this.objWarehouse = basic.objWarehouse();
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
          }
          this.dataDetails = {};
          this.preForm = {};
          this.getDetailsList(item.id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then((res) => {
          this.tableData = res.data.payload.allow_status_list;
          this.oldList = JSON.parse(
            JSON.stringify(res.data.payload.allow_status_list)
          );
          delete res.data.payload.allow_status_list;
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList(data) {
      this.loading = true;
      getDriverStatus(data)
        .then((res) => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          res.data.payload.rows.forEach((item) => {
            if (item.allow_status == "[]") {
              item.allow_status = "NO Data";
            } else {
              item.allow_status = item.allow_status.slice(
                1,
                item.allow_status.length - 1
              );
            }
            return;
          });
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows.map((item) => {
            let warehouse = nodata.noData(
              basic.objWarehouse(),
              item.warehouse_id,
              "warehouse"
            );
            item.warehouse_name = warehouse.name;
            return item;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addList() {
      let data = [];
      if (this.tableData) {
        this.tableData.forEach((item) => {
          data.push(Number(item.tracker_code));
        });
      }
      if (data.length === 0) {
        this.$Message["error"]({
          background: true,
          content: "status cannot be empty",
        });
        return;
      }
      this.dataDetails.allow_status = JSON.stringify(data);
      add(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    updateList() {
      let data = [];
      if (this.tableData) {
        this.tableData.forEach((item) => {
          data.push(Number(item.tracker_code));
        });
      }
      this.dataDetails.allow_status = JSON.stringify(data);
      update(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.ivu-divider-horizontal {
  margin: 10px 0;
}
</style>
